import { create } from "zustand";

/**
 * Полка или перегородка ячейки под курсором — в 3D или в списке панели.
 * Подсветка рисуется сценой, удаление по клавише Delete делает App.
 */
export interface HoveredShelvingBoard {
  moduleId: string;
  cellId: string;
  ref: string;
  /** Выделено касанием пальца: на детали ручка-стрелка, подсказка без клавиш. */
  touch?: boolean;
}

interface BoardHoverState {
  hovered: HoveredShelvingBoard | null;
  setHovered: (hovered: HoveredShelvingBoard | null) => void;
}

export const sameBoard = (a: HoveredShelvingBoard | null, b: HoveredShelvingBoard | null) =>
  a === b || Boolean(a && b && a.moduleId === b.moduleId && a.cellId === b.cellId && a.ref === b.ref &&
    Boolean(a.touch) === Boolean(b.touch));

export const useShelvingBoardHover = create<BoardHoverState>((set, get) => ({
  hovered: null,
  setHovered: hovered => { if (!sameBoard(get().hovered, hovered)) set({ hovered }); }
}));

export const boardLabel = (ref: string) => ref.startsWith("shelf") ? "Полка" : "Перегородка";

/**
 * Щелчок по стойке сетки в 3D: панель ячейки открывает поворот этой стойки.
 * stamp различает повторные щелчки по одной и той же стойке.
 */
export interface ShelvingUprightFocus {
  moduleId: string;
  dividerIndex: number;
  row: number;
  stamp: number;
}

export const useShelvingUprightFocus = create<{
  focus: ShelvingUprightFocus | null;
  setFocus: (focus: Omit<ShelvingUprightFocus, "stamp"> | null) => void;
}>((set) => ({
  focus: null,
  setFocus: focus => set({ focus: focus ? { ...focus, stamp: Date.now() } : null })
}));
